import { BillingPlanTier } from '@core/products-types';

export function getProductCodeOrThrow(codename: string) {
  switch (codename) {
    case 'launch':
      return BillingPlanTier.Launch;

    case 'scale':
      return BillingPlanTier.Scale;

    case 'lead':
      return BillingPlanTier.Lead;

    case 'start':
      return BillingPlanTier.Start;

    case 'grow':
      return BillingPlanTier.Grow;

    case 'optimize':
      return BillingPlanTier.Optimize;

    default:
      throw new Error(`Unsupported product codename ${codename}`);
  }
}
